import React from 'react'
import JustoLogo from '@components/JustoLogo'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'

export default function PoweredByJusto() {
  const darkMode = useIsDarkMode()

  return (
    <div className="flex items-center justify-center p-6 ">
      <a
        className="flex items-center opacity-50 hover:opacity-90 transition-all ease-in-out duration-150 hover:!no-underline"
        href="https://getjusto.com"
        target="_blank"
        rel="noreferrer">
        <span
          className={classnames({
            'text-xs font-normal mr-2': true,
            'text-black': !darkMode,
            'text-white': darkMode
          })}>
          Powered by
        </span>
        <JustoLogo height={18} />
      </a>
    </div>
  )
}
